    /**
     * Initialize Gallery Modal
     */
    function initGalleryModal() {
        let modalMainSwiper = null;
        let modalThumbsSwiper = null;
        const modalGallery = document.querySelector('#modal-gallery');
        const modalMain = modalGallery?.querySelector('.modal-gallery__main');
        const modalThumbs = modalGallery?.querySelector('.modal-gallery__thumbs');
        const modalClose = modalGallery?.querySelector('.modal-gallery__close');

        const toggleGalleryModal = document.querySelectorAll('.toggle-gallery-modal');

        toggleGalleryModal.forEach(toggle => {
            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                const galleryPostId = toggle.dataset.galleryPostId;

                if (galleryPostId && modalGallery && modalMain && modalThumbs) {
                    fetchGalleryImages(galleryPostId);
                }
            });
        });

        function stopAllVideos() {
            modalMain.querySelectorAll('video').forEach(video => {
                video.pause();
            });
        }

        function fetchGalleryImages(galleryPostId) {
            const base = (window.noh_theme_ajax && window.noh_theme_ajax.rest_url) ? window.noh_theme_ajax.rest_url.replace(/\/?$/, '/') : '/wp-json/';
            const url = base + 'noh/v1/gallery-post?id=' + encodeURIComponent(galleryPostId);

            fetch(url)
                .then(response => response.json())
                .then(data => {
                    if (data.main_html && data.thumbs_html) {
                        openGalleryModal(data.main_html, data.thumbs_html);
                    } else {
                        console.error('No gallery HTML returned for modal');
                    }
                })
                .catch(error => {
                    console.error('Error fetching gallery images:', error);
                });
        }

        function openGalleryModal(mainHtml, thumbsHtml) {
            if (!modalGallery || !modalMain || !modalThumbs) return;

            // Clear existing content
            modalMain.querySelector('.swiper-wrapper').innerHTML = mainHtml;
            modalThumbs.querySelector('.swiper-wrapper').innerHTML = thumbsHtml;

            // Show modal
            modalGallery.classList.add('visible');
            document.body.style.overflow = 'hidden';

            // GSAP animation for modal entrance
            if (typeof gsap !== 'undefined') {
                gsap.fromTo(modalMain,
                    {
                        y: 30,
                        opacity: 0
                    },
                    {
                        y: 0,
                        opacity: 1,
                        duration: 0.6,
                        ease: 'power2.out',
                        delay: 0.1
                    }
                );

                gsap.fromTo(modalThumbs,
                    {
                        y: 20,
                        opacity: 0
                    },
                    {
                        y: 0,
                        opacity: 1,
                        duration: 0.5,
                        ease: 'power2.out',
                        delay: 0.3
                    }
                );
            }

            // Initialize Swipers
            if (typeof Swiper !== 'undefined') {
                // Destroy existing instances
                if (modalMainSwiper) modalMainSwiper.destroy(true, true);
                if (modalThumbsSwiper) modalThumbsSwiper.destroy(true, true);

                // Initialize thumbnails first
                modalThumbsSwiper = new Swiper(modalThumbs, {
                    slidesPerView: 7,
                    spaceBetween: 10,
                    speed: 300,
                    watchSlidesProgress: true,
                    slideToClickedSlide: true,
                    freeMode: true,
                    loop: true,
                    breakpoints: {
                        0: { slidesPerView: 4 },
                        768: { slidesPerView: 7 }
                    }
                });

                // Initialize main swiper
                modalMainSwiper = new Swiper(modalMain, {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    speed: 800,
                    easing: 'ease-in-out',
                    loop: true,
                    thumbs: { swiper: modalThumbsSwiper },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    keyboard: {
                        enabled: true,
                    },
                    on: {
                        slideChange: stopAllVideos,
                    },
                });
            }
        }

        function closeGalleryModal() {
            stopAllVideos();
            if (modalGallery) {
                // GSAP animation for modal exit (reverse of entrance)
                if (typeof gsap !== 'undefined') {
                    const tl = gsap.timeline({
                        onComplete: () => {
                            modalGallery.classList.remove('visible');
                            document.body.style.overflow = '';

                            // Destroy Swiper instances
                            if (modalMainSwiper) {
                                modalMainSwiper.destroy(true, true);
                                modalMainSwiper = null;
                            }
                            if (modalThumbsSwiper) {
                                modalThumbsSwiper.destroy(true, true);
                                modalThumbsSwiper = null;
                            }
                        }
                    });

                    // Reverse the entrance animation
                    tl.to(modalMain, {
                        y: 30,
                        opacity: 0,
                        duration: 0.6,
                        ease: 'power2.in'
                    })
                    .to(modalThumbs, {
                        y: 20,
                        opacity: 0,
                        duration: 0.5,
                        ease: 'power2.in'
                    }, 0.1);
                } else {
                    // Fallback without GSAP
                    modalGallery.classList.remove('visible');
                    document.body.style.overflow = '';

                    // Destroy Swiper instances
                    if (modalMainSwiper) {
                        modalMainSwiper.destroy(true, true);
                        modalMainSwiper = null;
                    }
                    if (modalThumbsSwiper) {
                        modalThumbsSwiper.destroy(true, true);
                        modalThumbsSwiper = null;
                    }
                }
            }
        }

        // Close modal events
        if (modalClose) {
            modalClose.addEventListener('click', closeGalleryModal);
        }

        // Close on overlay click
        const overlay = modalGallery?.querySelector('.modal-gallery__overlay');
        if (overlay) {
            overlay.addEventListener('click', closeGalleryModal);
        }

        // Close on ESC key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && modalGallery?.classList.contains('visible')) {
                closeGalleryModal();
            }
        });
    }
